module.exports = __webpack_public_path__ + "img/aaaa1.7c4c7c9c.png";